import { Container, Graphics, Point, Sprite, Text } from 'pixi.js';
import { storageManager } from './../common/StorageManager';
import { dataImporter } from './../DataImporter';

export class UiScreen extends Container {
    constructor(game) {
        super();

        this.camera = game.camera;
        this.tilemap = game.tilemap;

        this.mapBorder = new Sprite.from(dataImporter.currPack.ui.mapBorderImage);
        this.mapBorder.anchor.set(1, 1);
        this.scoreUi = new Sprite.from(dataImporter.currPack.ui.scoreImage);
        this.scoreUi.anchor.set(1, 1);
        this.scoreUi.x = -80;
        this.miniMap = new Sprite.from(dataImporter.currPack.ui.minimap);
        this.miniMap.anchor.set(0.5);
        this.miniMap.position.set(dataImporter.currPack.ui.minimapPos.x, dataImporter.currPack.ui.minimapPos.y);

        this.scoreText = new Text("117", {
            align: "right",
            fill: "#ffffff",
            fontStyle: "bold",
            fontSize: 111
        });
        this.scoreText.anchor.set(1);
        this.scoreText.x = -260;

        this.addChild(this.scoreUi);
        this.addChild(this.mapBorder);
        this.mapBorder.addChild(this.miniMap);
        this.scoreUi.addChild(this.scoreText);

        this.cameraScale = new Point(this.miniMap.width / this.tilemap.worldWidth, this.miniMap.height / this.tilemap.worldHeight);
        this.cameraBounds = this.drawCameraBounds(this.camera, this.cameraScale);

        this.miniMap.addChild(this.cameraBounds);
        this.setScoreText();

        storageManager.ee.on("scoremodified", () => this.setScoreText(), this);
    }

    drawCameraBounds(camera, scale) {
        let bounds = camera.getVisibleBounds();
        let rect = new Graphics();
        rect.position.set(0);
        let x = (bounds.x * this.cameraScale.x) - this.miniMap.width / 2;
        let y = (bounds.y * this.cameraScale.y) - this.miniMap.height / 2;
        rect.beginFill(0xff0000, 0.25);
        rect.lineStyle(3, 0xff0000);
        rect.drawRect(x, y, bounds.width * scale.x, bounds.height * scale.y);
        rect.endFill();
        return rect;
    }

    setScoreText() {
        let text = Math.min(storageManager.getScore(), 999999);
        text = text.toString();
        this.scoreText.text = text.padStart(6, "0");
    }

    createMap() {

    }

    update(){
        if (this.cameraBounds && this.cameraBounds.geometry){
            this.updateCameraBounds();
        }
    }

    updateCameraBounds(){
        this.cameraBounds.clear();
        let bounds = this.camera.getVisibleBounds();
        let x = (bounds.x * this.cameraScale.x) - this.miniMap.width / 2;
        let y = (bounds.y * this.cameraScale.y) - this.miniMap.height / 2;
        this.cameraBounds.beginFill(0xff0000, 0.25);
        this.cameraBounds.lineStyle(3, 0xff0000);
        this.cameraBounds.drawRect(x, y, bounds.width * this.cameraScale.x, bounds.height * this.cameraScale.y);
    }
}
